import { useState } from "react";
import { Play } from "lucide-react";

export default function VideoTile({ v, testid, cover }) {
  const [playing, setPlaying] = useState(false);
  return (
    <div className="relative aspect-video bg-black overflow-hidden" data-testid={testid}>
      {playing ? (
        <iframe className="absolute inset-0 w-full h-full" src={`https://www.youtube.com/embed/${v.youtubeId}?autoplay=1&rel=0`} title={v.title}
          allow="autoplay; encrypted-media; picture-in-picture" allowFullScreen />
      ) : (
        <button onClick={() => setPlaying(true)} data-testid={`${testid}-play`} aria-label={`Play ${v.title}`} className="group absolute inset-0 w-full h-full">
          <img src={v.poster} alt={v.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
          <span className="absolute inset-0 bg-black/25 group-hover:bg-black/10 transition-colors" />
          {cover}
          <span className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-16 h-16 rounded-full border border-white/80 bg-black/20 flex items-center justify-center text-white"><Play size={22} /></span>
        </button>
      )}
    </div>
  );
}
